import { StyledSvg } from "baseui/icon";
import React from "react";

export const DocsIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 30 30" {...props}>
    <path d="M24.707 7.793L19.207 2.293C19.019 2.105 18.765 2 18.5 2H7C5.895 2 5 2.895 5 4V26C5 27.105 5.895 28 7 28H23C24.105 28 25 27.105 25 26V8.5C25 8.235 24.895 7.981 24.707 7.793ZM19 23H10C9.448 23 9 22.552 9 22C9 21.448 9.448 21 10 21H19C19.552 21 20 21.448 20 22C20 22.552 19.552 23 19 23ZM20 19H10C9.448 19 9 18.552 9 18C9 17.448 9.448 17 10 17H20C20.552 17 21 17.448 21 18C21 18.552 20.552 19 20 19ZM20 15H10C9.448 15 9 14.552 9 14C9 13.448 9.448 13 10 13H20C20.552 13 21 13.448 21 14C21 14.552 20.552 15 20 15ZM19 9C18.448 9 18 8.552 18 8V3.904L23.096 9H19Z" />
  </StyledSvg>
);
